import { ZomentumPSAsArray } from "@/Contracts/common";
import pick from "lodash/pick";
import { useSelector } from "react-redux";
import { GlobalState } from "@/Reducers/interface";
import { Integrations } from "@/Contracts/Settings";
import { ZeroOrNegative, BlockedQuantityKeys } from "./interface";

/**
 * @description Finds a connected integration which allows/does not allow zero/negative quantity in quote block products present in a document.
 * @returns Map<negative/zero, { name of integration: string, value: boolean }>
 * @author Idrees
 */

export const useAllowZeroOrNegativeQuantity = (): ZeroOrNegative => {
	const quickBooksKey = "quickbooks";
	const haloKey = "halo";

	const integrationNames: Partial<Record<keyof Integrations, string>> = {
		repair_shopr: "RepairShopr",
		kaseya: "Kaseya BMS",
		connectwise: "ConnectWise PSA",
		autotask: "Autotask",
		syncro: "Syncro",
		quickbooks: "Quickbooks Online",
		halo: "HaloPSA",
		hubspot: "HubSpot"
	};

	const { integrations } = useSelector((state: GlobalState) => {
		return {
			integrations: pick(state.user.userCompany.integrations, [
				...ZomentumPSAsArray,
				haloKey,
				quickBooksKey
			])
		};
	});

	const presentIntegrations = Object.keys(integrations).map(integration => {
		const integrationData =
			integrations[integration as keyof Partial<Integrations>];
		return {
			name: integrationNames[integration as keyof Partial<Integrations>],
			blockedQuantityKeys: pick(integrationData, [
				"block_negative_quantity",
				"block_zero_quantity"
			]) as BlockedQuantityKeys
		};
	});

	const negative = presentIntegrations.find(
		integration => integration.blockedQuantityKeys.block_negative_quantity
	);
	const zero = presentIntegrations.find(
		integration => integration.blockedQuantityKeys.block_zero_quantity
	);

	return {
		negativeQuantity: {
			name: negative?.name,
			value: !negative?.blockedQuantityKeys.block_negative_quantity
		},
		zeroQuantity: {
			name: zero?.name,
			value: !zero?.blockedQuantityKeys.block_zero_quantity
		}
	};
};
